import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

// Define ContainerType locally to avoid export binding issues
export interface ContainerType {
  id: string;
  name: string;
}

export const containerTypesQueryAtom = createQueryAtomFactory(
  'trade.containerTypes',
  (params: {
    ids?: string[];
    searchTerm?: string;
    offset?: number;
    limit?: number;
  }) => ({
    containerTypes: {
      __args: {
        filter: {
          ids: params.ids ?? [],
          searchTerm: params.searchTerm ?? '',
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 100,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): { containerTypes: ContainerType[] } => ({
      containerTypes:
        data?.containerTypes.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
        })) ?? [],
    }),
  },
);
